import { Check, X } from "lucide-react";
import { Container, Chapter, FadeUp } from "./primitives";

const ROWS = [
  { k: "Lead discovery", t: "Manual search", u: "AI-powered" },
  { k: "CRM", t: "Spreadsheet", u: "Built-in pipeline" },
  { k: "Analysis", t: "None", u: "Intent, sentiment, fit" },
  { k: "Automation", t: "None", u: "Approve → schedule → send" },
  { k: "Scheduling", t: "Manual", u: "AI-timed" },
  { k: "Approval workflow", t: "Ad-hoc", u: "Team review, audit trail" },
  { k: "Analytics", t: "None", u: "Reply-rate, ROI, velocity" },
  { k: "Audit trail", t: "None", u: "Every action logged" },
];

export default function WhyUs() {
  return (
    <section id="why" data-testid="why-section" className="relative py-32 md:py-40 border-t border-white/10">
      <Container>
        <Chapter
          number="06"
          kicker="Why choose us"
          title={<>The obvious upgrade over <span className="font-serif-x italic">manual</span> outreach.</>}
          description="Two rows. One decision. We built SocialLead AI to remove the busywork you shouldn’t be doing in 2026."
        />

        <FadeUp delay={0.15}>
          <div className="mt-14 overflow-hidden rounded-3xl border border-white/10">
            <div className="grid grid-cols-3 bg-white/[0.03] border-b border-white/10">
              <div className="p-5 md:p-6">
                <div className="text-[10px] font-mono-x uppercase tracking-[0.22em] text-white/40">Capability</div>
              </div>
              <div className="p-5 md:p-6 border-l border-white/10">
                <div className="text-[10px] font-mono-x uppercase tracking-[0.22em] text-white/40">Traditional Outreach</div>
                <div className="mt-1 font-display text-lg text-white/70 line-through decoration-white/20">Spreadsheets & DMs</div>
              </div>
              <div className="p-5 md:p-6 border-l border-white/10 bg-gradient-to-b from-[#4F46E5]/12 to-transparent">
                <div className="text-[10px] font-mono-x uppercase tracking-[0.22em] text-[#a78bfa]">SocialLead AI</div>
                <div className="mt-1 font-display text-lg">One intelligent platform</div>
              </div>
            </div>
            {ROWS.map((r, i) => (
              <div key={r.k} className={`grid grid-cols-3 ${i !== ROWS.length - 1 ? "border-b border-white/8" : ""}`}>
                <div className="p-4 md:p-5 text-sm md:text-[15px] text-white/85">{r.k}</div>
                <div className="p-4 md:p-5 border-l border-white/8 flex items-center gap-2 text-white/55 text-sm">
                  <X className="h-4 w-4 text-white/30" strokeWidth={2} />
                  {r.t}
                </div>
                <div className="p-4 md:p-5 border-l border-white/8 flex items-center gap-2 text-white text-sm bg-gradient-to-r from-[#4F46E5]/8 to-transparent">
                  <Check className="h-4 w-4 text-emerald-300" strokeWidth={2.5} />
                  {r.u}
                </div>
              </div>
            ))}
          </div>
        </FadeUp>
      </Container>
    </section>
  );
}
